import { render, staticRenderFns } from "./translations.vue?vue&type=template&id=a0b31766&scoped=true"
import script from "./translations.vue?vue&type=script&lang=js"
export * from "./translations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b31766",
  null
  
)

export default component.exports